import { useState } from 'react'
import { AccountMember } from '@/javascript/domain/entities'

export type MemberConfiguration = {
  initial: {
    latitude: number
    longitude: number
    address: string
  }
  final: {
    latitude: number
    longitude: number
    address: string
  }
  workLimit: number | null
}

const useRoutingMembers = () => {
  const [selectedMembers, setSelectedMembers] = useState<AccountMember[]>([])
  const [memberConfigurations, setMemberConfigurations] = useState<Record<number, MemberConfiguration>>({})

  return {
    selectedMembers, setSelectedMembers,
    memberConfigurations, setMemberConfigurations,
  }
}

export default useRoutingMembers
